module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_photogenic@2x-393aea4225386be1eaf4ad2bd8b5e828.webp";